/**
 * Futures-Spot Symbol Types
 *
 * Types for representing cryptocurrency symbols available on both
 * spot and futures markets for arbitrage opportunities.
 */

/**
 * Exchange enum matching existing dashboard types
 */
export enum Exchange {
  Binance = "Binance",
  BinanceFutures = "BinanceFutures",
  Upbit = "Upbit",
  Bithumb = "Bithumb",
}

/**
 * Represents a cryptocurrency symbol available on both spot and futures markets
 */
export interface FuturesSpotSymbol {
  /** Base currency (e.g., "BTC", "ETH") */
  baseAsset: string;

  /** Quote currency (e.g., "USDT", "KRW") */
  quoteAsset: string;

  /** Exchanges where spot trading is available */
  spotExchanges: Exchange[];

  /** Exchange where futures trading is available (Binance only for now) */
  futuresExchange: Exchange;

  /** Exchange-specific spot symbol formats */
  spotSymbols: Record<Exchange, string>;

  /** Futures symbol in Binance format (e.g., "BTCUSDT") */
  futuresSymbol: string;

  /** Normalized symbol format (e.g., "BTC/USDT") */
  normalizedSymbol: string;
}
